import React from 'react';


// https://developers.heap.io/reference#track
type Properties = Record<string | number, string | number | boolean | undefined>

declare global {
  interface Window {
    heap?: {
      track: (eventName: string, propertiesObj: Properties) => void
    }
  }
}

export function trackHeapCustomEvent(eventName: string, propertiesObj: Properties = {}) {
  if ('heap' in window && window.heap) {
    window.heap.track(eventName, propertiesObj);
  }
}

export function useHeapCustomEvent(eventName: string) {
  React.useEffect(() => {
    trackHeapCustomEvent(eventName);
  }, [eventName]);
}
